import Browser from '@mindful-web/marko-web/browser';
import Shared from '@randall-reilly/package-global/browser';
import RigDig from '@randall-reilly/package-rigdig/browser';

Shared(Browser);
RigDig(Browser);

export default Browser;
